import React from 'react';
import { reconciliationRows } from '../../data/gtbankUatData';
import Div from '../Div';
import { UatPageShell, UatTable } from './UatDocumentationPage';

const columns = [
  { key: 'date', label: 'Date' },
  { key: 'refNo', label: 'Ref No' },
  { key: 'gatewayTransactionId', label: 'Gateway Transaction ID' },
  { key: 'customer', label: 'Customer' },
  { key: 'amount', label: 'Amount' },
  { key: 'currency', label: 'Currency' },
  { key: 'paymentStatus', label: 'Payment Status' },
  { key: 'settlementStatus', label: 'Settlement Status' },
  { key: 'notes', label: 'Notes' },
];

export default function AdminReconciliationPage() {
  return (
    <UatPageShell
      title="Finance Reconciliation Report"
      breadcrumb="Reconciliation"
      heading="Finance Reconciliation Report"
      subtitle="Bank-review ready reconciliation sample"
    >
      <Div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
          marginBottom: 24,
        }}
      >
        <Div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <strong>Date Filter</strong>
          <input
            type="text"
            value="11 June 2026"
            readOnly
            className="cs-form_field cs-bg_color_1"
            style={{ width: 220 }}
          />
        </Div>
        <button type="button" className="cs-btn cs-style1">
          <span>Export CSV</span>
        </button>
      </Div>
      <UatTable columns={columns} rows={reconciliationRows} />
    </UatPageShell>
  );
}
